import { LandingPageOption } from '@vae/server/dist/client'

export const getLandingPageLabel = (landingPage?: LandingPageOption) => {
	switch (landingPage) {
		case 'overview':
			return 'Yleiskatsaus'
		case 'consumption':
			return 'Kulutus'
		case 'spotMargin':
			return 'Pörssihinta'
		case 'devices':
			return 'Laitteet'
		case 'saving':
			return 'Säästö'
		default:
			return ''
	}
}
